<template>
  <div class="app-footer">
    <div class="footer-container">
      <!-- 导航链接区域 -->
      <div class="footer-nav-section">
        <div class="nav-grid">
          <!-- 第一列：买域名 -->
          <div
            class="nav-column"
            v-for="(item, index) in actionList"
            :key="index"
          >
            <h3 class="column-title">{{ item.name }}</h3>
            <ul class="column-links">
              <li v-for="(i, ind) in item.children" :key="ind">
                <a :href="i.value" class="nav-link">{{ i.key }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 友情链接区域 -->

      <!-- 备案信息和版权 -->
      <div class="footer-copyright">
        <div class="copyright-content">
          <!-- <div class="footer-links-section" v-if="linkList.length > 0"> -->
          <div class="links-container" v-if="linkList.length > 0">
            <span class="links-label">友情链接：</span>
            <span class="links-list">
              <a
                v-for="(item, index) in linkList"
                :key="index"
                :href="item.lowParam"
                target="_blank"
                class="link-item"
              >
                {{ item.lowName }}
              </a>
            </span>
          </div>
          <!-- </div> -->
          <p>
            <a
              style="color: #bdc3c7; text-decoration: none"
              href="https://beian.miit.gov.cn/"
              target="_blank"
              >&copy; {{ bah }}</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { indexApi } from "@/api/index";

// 响应式判断

const bah = ref("");
const linkList = ref([]);
const actionList = ref([]);
const init = () => {
  indexApi.getIndex().then((res) => {
    console.log("首页信息:", res);
    if (res.length > 0) {
      bah.value = res.filter((item) => item.lowType == 1)[0]?.lowParam || "";
      linkList.value = res.filter((item) => item.lowType == 2);
      const list = res.filter((item) => item.lowType == 10);
      actionList.value = list.map((item) => {
        return {
          name: item.firstTitle,
          children: JSON.parse(item.secondTitle),
        };
      });
    }
  });
};

// 初始化
onMounted(() => {
  init();
});
</script>

<style scoped lang="scss">
.app-footer {
  background-color: #2c3e50;
  color: white;
  margin-top: auto;
  position: relative;
  width: 100%;
}

.footer-container {
  width: 92%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 16px 20px;

  @media (min-width: 768px) {
    width: 90%;
    padding: 50px 20px 30px;
  }

  @media (min-width: 1200px) {
    width: 80%;
  }
}

/* 导航区域 */
.footer-nav-section {
  @media (min-width: 768px) {
    margin-bottom: 40px;
  }

  .nav-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 30px 20px;

    @media (min-width: 576px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 768px) {
      grid-template-columns: repeat(3, 1fr);
      gap: 40px 30px;
    }

    @media (min-width: 992px) {
      grid-template-columns: repeat(5, 1fr);
      gap: 40px;
    }

    .nav-column {
      .column-title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;
        color: white;
        position: relative;
        padding-bottom: 8px;

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 40px;
          height: 2px;
          background-color: #42b883;

          @media (max-width: 767px) {
            width: 30px;
          }
        }

        @media (max-width: 767px) {
          font-size: 15px;
          margin-bottom: 15px;
        }
      }

      .column-links {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          margin-bottom: 12px;

          &:last-child {
            margin-bottom: 0;
          }

          @media (max-width: 767px) {
            margin-bottom: 10px;
          }
        }

        .nav-link {
          color: #bdc3c7;
          text-decoration: none;
          font-size: 14px;
          transition: all 0.3s;
          display: inline-block;
          position: relative;
          padding-left: 0;

          &:hover {
            color: #42b883;
            padding-left: 8px;

            &::before {
              content: "›";
              position: absolute;
              left: 0;
              color: #42b883;
            }
          }

          &.disabled {
            color: #7f8c8d;
            cursor: not-allowed;

            &:hover {
              color: #7f8c8d;
              padding-left: 0;

              &::before {
                display: none;
              }
            }
          }

          @media (max-width: 767px) {
            font-size: 13px;
          }
        }
      }
    }
  }
}

/* 友情链接区域 */
.footer-links-section {
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 20px;
}

/* 备案和版权信息区域 */
.footer-copyright {
  text-align: center;

  @media (min-width: 768px) {
  }

  .links-container {
    text-align: center;
    display: flex;
    align-items: center;
    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
      gap: 16px;
    }

    .links-label {
      font-size: 14px;
      color: #bdc3c7;
      white-space: nowrap;
      flex-shrink: 0;

      @media (max-width: 768px) {
        font-size: 13px;
        text-align: center;
      }
    }

    .links-list {
      display: flex;
      flex-wrap: wrap;
      gap: 12px 20px;

      @media (max-width: 768px) {
        justify-content: center;
        gap: 12px;
      }

      .link-item {
        color: white;
        text-decoration: none;
        font-size: 14px;
        padding: 4px 0;
        transition: all 0.3s;
        position: relative;
        white-space: nowrap;

        @media (max-width: 768px) {
          font-size: 13px;
          padding: 2px 0;
        }

        &:hover {
          color: #42b883;

          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 1px;
            background-color: #42b883;
            transform: scaleX(1);
            transition: transform 0.3s;
          }
        }

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 1px;
          background-color: #42b883;
          transform: scaleX(0);
          transition: transform 0.3s;
        }
      }
    }
  }

  .copyright-content {
    .icp-info {
      margin-bottom: 15px;

      p {
        color: #bdc3c7;
        font-size: 12px;
        line-height: 1.8;
        margin: 4px 0;

        @media (min-width: 768px) {
          font-size: 13px;
          display: inline-block;

          &:first-child {
            margin-right: 20px;
          }
        }
      }

      .icp-link {
        color: #42b883;
        text-decoration: none;
        transition: color 0.3s;

        &:hover {
          color: white;
          text-decoration: underline;
        }
      }
    }

    p {
      color: #95a5a6;
      font-size: 12px;
      line-height: 1.6;
      margin: 4px 0;

      @media (min-width: 768px) {
        font-size: 13px;
      }
    }

    .mobile-notice {
      font-size: 13px;
      color: rgba(189, 195, 199, 0.8);
      margin-top: 10px;

      @media (min-width: 769px) {
        display: none;
      }
    }
  }
}

/* 触摸设备优化 */
@media (hover: none) and (pointer: coarse) {
  .nav-link:hover {
    color: #bdc3c7;
    padding-left: 0;
  }

  .nav-link:hover::before {
    display: none;
  }

  .nav-link:active {
    color: #42b883;
    padding-left: 8px;

    &::before {
      content: "›";
      position: absolute;
      left: 0;
      color: #42b883;
    }
  }

  .link-item:hover {
    color: white;
  }

  .link-item:hover::after {
    transform: scaleX(0);
  }

  .link-item:active {
    color: #42b883;
  }
}

/* 打印样式 */
@media print {
  .app-footer {
    display: none;
  }
}
</style>